<template>
  <div>
    <InventoryCountingAddNew
      :isSidebarActive="isSidebarActiveTakingSidebar"
      :data="infoData"
      @closeSidebar="toggleStockTakingSidebar"
    />
    <vs-prompt
      :title="$t('Warning')"
      :acceptText="$t('Submit')"
      :cancelText="$t('Cancel')"
      @accept="stockTakingDelete"
      :active.sync="isSidebarActiveProcess"
      color="danger"
    >
      <div style="text-align: center" class="con-exemple-prompt">
        <span>
          <b-row style="margin-top: 15px">
            <b-col cols="12" align-self="center">
              <h6>{{ $t("DoConfirm") }}</h6>
            </b-col>
          </b-row>
        </span>
      </div>
    </vs-prompt>

    <vs-card>
      <b-row>
        <b-col cols="6" style="padding-right: 2px">
          <b-col>
            <b-button
              class="bg-warning"
              style="border-color: white"
              v-on:click="addStockTaking()"
            >
              <Icon
                :icon="'mingcute:add-line'"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("AddNewStockTaking") }}
            </b-button>
          </b-col>
        </b-col>
        <b-col cols="6" style="padding-right: 2px">
          <b-row align-h="end" style="padding-right: 2px">
            <b-col cols="12" md="auto" style="padding-left: 0">
              <vs-button
                type="border"
                size="small"
                color="success"
                style="border-radius: 8px; font-size: small"
                @click="
                  takingStatus = true;
                  addInfoData();
                "
                class="vs-con-loading__container"
                id="loading-picking"
                >{{ $t("Completed") }}</vs-button
              >
            </b-col>
            <b-col cols="12" md="auto" style="padding-left: 0">
              <vs-button
                type="border"
                size="small"
                color="danger"
                style="border-radius: 8px; font-size: small"
                @click="
                  takingStatus = false;
                  addInfoData();
                "
                class="vs-con-loading__container"
                id="loading-packing"
                >{{ $t("NotCompleted") }}</vs-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import threeInfoButtonsDynamic from "../CellRenderers/threeInfoButtonsDynamic.vue";
import InventoryCountingAddNew from "./InventoryCountingAddNew.vue";
import moment from "moment";
export default {
  data() {
    return {
      takingStatus: false,
      isSidebarActiveProcess: false,
      addNewInfoDataSidebar: false,
      isSidebarActiveTakingSidebar: false,
      isSidebarActiveTakingItemSidebar: false,
      addNewActSidebar: false,
      infoData: [],
      processList: [],
      stockTakingData: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    InventoryCountingAddNew,
    threeInfoButtonsDynamic,
    AgGridVue,
    Icon,
  },
  methods: {
    addStockTakingItem() {
      console.log(this.infoData);
      this.$router
        .push({
          name: "inventory-counting-item",
          params: {
            data: JSON.stringify(this.infoData),
          },
        })
        .catch(() => {});
    },

    toggleStockTakingSidebar(val = false) {
      if (val == false) {
        this.infoData = "";
        this.addInfoData();
      }
      this.isSidebarActiveTakingSidebar = val;
    },
    addStockTaking() {
      this.toggleStockTakingSidebar(true);
    },
    closeInfoData() {
      this.addNewInfoDataSidebar = false;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    toggleActSidebar(val = false) {
      this.addNewActSidebar = val;
    },
    getStockTakingColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 150,
          pinned: "left",
          cellRendererFramework: "threeInfoButtonsDynamic",
          cellRendererParams: {
            detailMethodsOne: "stockTakingDetail",
            iconDetailOne: "material-symbols:edit",
            iconColorOne: "#065a82",
            tooltipOne: "Edit",
            detailMethodsTwo: "stockTakingDelete",
            iconDetailTwo: "ic:baseline-remove-circle",
            iconColorTwo: "#fe6d73",
            tooltipTwo: "Delete",
            detailMethodsTree: "addStockTakingItem",
            iconDetailTree: "clarity:rack-server-solid-badged",
            iconColorTree: "#17c3b2",
            tooltipTree: "ListStockTakingItem",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("InfoType") == false
          )
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },
    addInfoData() {
      const vs = this.$vs;

      this.$store
        .dispatch("stock/listStockTaking", this.takingStatus)
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    stockTakingDelete() {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteStockTaking", this.deleteData.StockTakingId)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.addInfoData();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    stockTaking: {
      get() {
        return this.$store.state.stock.StockTaking;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.addInfoData();
    this.$root.$on("stockTakingDetail", (data) => {
      this.infoData = data;
      this.addStockTaking(data);
    });
    this.$root.$on("addStockTakingItem", (data) => {
      this.infoData = data;
      this.addStockTakingItem();
    });
    this.$root.$on("stockTakingDelete", (data) => {
      this.deleteData = data;
      this.isSidebarActiveProcess = true;
    });
    this.$root.$on("closeInfoData", () => {
      this.closeInfoData();
    });
  },
  beforeDestroy() {
    this.$root.$off("stockTakingDetail");
    this.$root.$off("closeInfoData");
    this.$root.$off("stockTakingDelete");
    this.$root.$off("addStockTakingItem");
  },
  watch: {
    stockTaking(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getStockTakingColumnList();
      }

      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
